import React from "react";
import {Box, Button, Columns} from "react-bulma-components";
import Collapsible from "react-collapsible";
import useInput from "../../../../hooks/useInput";
import {useDispatch, useSelector} from "react-redux";
import {createSetDataFreshAction} from "../../../../actions/dataActions";
import {getDataFresh} from "../../../../state/selectors";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import usePostVehicleMake from "../../../../hooks/usePostVehicleMake";


export default function NewVehicleMake(){

    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name"
    });

    let [maintenance_cost_per_mile, maintenance_costInput, setMaintenanceCostPerMile] = useInput({
        type: "number",
        label: "Maintenance Cost Per Mile (£)",
        initialValue: 0.1,
        currency: true
    });


    let [additional_depreciation_per_mile, additional_depreciation_per_mileInput, setAdditionalDepreciationPerMile] = useInput({
        type: "number",
        label: "Additional Depreciation Per Mile (£)",
        initialValue: 0.01,
        currency: true
    });

    const clear = () =>{
        setName("");
        setMaintenanceCostPerMile(0.1)
        setAdditionalDepreciationPerMile(0.01)
    }
    const [, postMake] = usePostVehicleMake({
        name: name,
        maintenance_cost_per_mile: maintenance_cost_per_mile,
        additional_depreciation_per_mile: additional_depreciation_per_mile
    })
    const handleSubmit = () => {
        postMake().then(() => (
            clear()
        ))
    }

    return (
        <Box className="settings_type">
          <Collapsible
            className="title"
            triggerOpenedClassName="title"
            trigger="Add Vehicle Make"
          >
              <Columns>
                  {nameInput}
                  {maintenance_costInput}
                  {additional_depreciation_per_mileInput}
              </Columns>
              <Columns>
                <Columns.Column>
                    <Button
                        color={"success"}
                        fullwidth
                        onClick={handleSubmit}
                    >
                        Add +
                    </Button>
                </Columns.Column>
              </Columns>
          </Collapsible>
        </Box>
    )
}